// extracted by mini-css-extract-plugin
module.exports = {"container":"ConfirmPasswordInput_container__1XRJJ","input":"ConfirmPasswordInput_input__25i37"};